module.exports = __webpack_public_path__ + "assets/pouting_face.4b8042b6a4cae2ca730b72a1d3bf5042.png";